import { makeStyles } from '@material-ui/core';

const useStyles = makeStyles({
  root: {
    display: 'flex',
    flexDirection: 'column',
    gap: '0.5rem',
    width: '100%',

    '& > div': {
      border: '1px solid rgba(0, 0, 0, 0.23)',
      borderRadius: '5px',
      padding: '0.25rem 0.5rem',
      minHeight: '1.5rem',

      '& > p': {
        margin: 0,
      },
    },
  },
});

export default function DeliveryNoteHandwriteBoxes() {
  const classes = useStyles();

  return (
    <div className={classes.root}>
      <div>
        <p>CAISSES :</p>
      </div>
      <div>
        <p>NOTE :</p>
      </div>
    </div>
  );
}
